export function showDevToolsWarning(): void {
  const warningStyle = 'font-size: 36px; color: red; font-weight: bold;';
  const normalStyle = 'font-size: 12px;';
  const boldStyle = 'font-size: 16px; font-weight: bold;';

  console.log('%cUWAGA!', warningStyle);
  console.log('%cTa funkcja przeglądarki jest przeznaczona wyłącznie dla programistów serwisu.', normalStyle);
  console.log('%cJeśli ktoś polecił Ci edytować stronę w ten sposób, jest to próba ataku i wyłudzenia danych.\n' +
              'Nic tutaj nie wklejaj ani nie wpisuj.', boldStyle);
  console.log('%cZamknij okno tego narzędzia (kliknij "X" w prawym, górnym rogu).\n' +
              'Poinformuj nas o próbie ataku i wyślij zgłoszenie na e-mail: info.eurzad@mf.gov.pl', normalStyle);
}